<script lang="ts">
  import { xhr, toast } from "$app/utils"

  interface Props {
    subscription: SubscriptionType
    status: string
    onupdate: (plan: PlanType) => void
  }

  let { subscription, status = "", onupdate }: Props = $props()

  let form = $state({})
  let saving = $state(false)

  function saveSubscription(): void {
    if (status === "edit") {
      updateSubscription()
    } else {
      createSubscription()
    }
  }

  let errors: any = $state({})

  async function updateSubscription(): Promise<void> {
    try {
      saving = true
      const resp = await xhr.patch(
        `/admin/subscriptions/${subscription.id}.json`,
        {
          subscription: form
        }
      )
      toast("Subscription updated successfully", "success")
      onupdate(resp.data)
    } catch (e) {
      console.log(e)
      toast("There was an error saving subscription", "error")
      errors = e.response.data.errors
    } finally {
      saving = false
    }
  }

  async function createSubscription(): Promise<void> {
    try {
      errors = {}
      saving = true
      const resp = await xhr.patch("/admin/subscriptions", {
        plan: form
      })
      toast("Subscription created successfully", "success")
    } catch (e) {
      console.log(e)
      toast("There was an error creating subscription", "error")
    } finally {
      saving = false
    }
  }

  function setForm(): void {
    form = {
      name: subscription.name,
      stripe_id: subscription.stripe_id,
      notes: subscription.notes,
      subscription_type: subscription.subscription_type,
      billing_interval: subscription.billing_interval,
      stripe_coupon: subscription.stripe_coupon,
      full_access_total: subscription.full_access_total,
      team_member_total: subscription.team_member_total,
      recognition_member_total: subscription.recognition_member_total
    }
  }

  if (status) {
    setForm()
  }
</script>

<h2 class="text-base font-semibold leading-6 text-gray-900">
  {status === "edit" ? "Edit" : "New"} Subscription
</h2>

<div class="grid grid-cols-2 gap-4 py-2">
  <div class="input-cont">
    <label for="">Subscription Name</label>
    <input type="text" class="input" bind:value={form.name} />
    <div class="text-red-500">
      {errors.name || ""}
    </div>
  </div>
  <div class="input-cont">
    <label for="">Subscription Type</label>
    <select bind:value={form.subscription_type}>
      <option value="free">Free</option>
      <option value="standard">Standard</option>
      <option value="unlimited">Unlimited</option>
    </select>
  </div>
</div>

<div class="input-cont py-2">
  <label for="">Stripe Subscription ID</label>
  <input type="text" class="input" bind:value={form.stripe_id} />
</div>

<div class="input-cont py-2">
  <label for="">Notes</label>
  <input type="text" class="input" bind:value={form.notes} />
</div>

<div class="input-cont py-2">
  <label for="">Billing Interval</label>
  <select bind:value={form.billing_interval}>
    <option value="month">Month</option>
    <option value="year">Year</option>
    <option value="not_applicable">N/A</option>
  </select>
</div>

<div class="grid grid-cols-3 gap-4 py-2">
  <div class="input-cont">
    <label for="">Full-Access Total</label>
    <input type="number" class="input" bind:value={form.full_access_total} />
  </div>

  <div class="input-cont">
    <label for="">Team Member Total</label>
    <input type="text" class="input" bind:value={form.team_member_total} />
  </div>
  <div class="input-cont">
    <label for="">Recognition Member Total</label>
    <input
      type="text"
      class="input"
      bind:value={form.recognition_member_total}
    />
  </div>
</div>

<div class="p-4 text-center">
  <button class="btn big primary" disabled={saving} onclick={saveSubscription}>
    {status === "edit" ? "Update" : "Create"}
  </button>
</div>
